<div class="main-container">
  <form [formGroup]="ProductionDeviceAddForm" novalidate>
    <div class="page-header">
      <div class="routing-buttons">
        <div
          class="action-button back-button"
          (click)="navigateBack()"
          tabindex="0"
          (keydown.enter)="navigateBack()"
        >
          <mat-icon class="icon back-icon">arrow_back</mat-icon>
        </div>
        <div
          class="action-button reload-button"
          (click)="ngOnInit()"
          tabindex="0"
          (keydown.enter)="ngOnInit()"
        >
          <mat-icon class="icon reload-icon">refresh</mat-icon>
        </div>
        @if (ProductionDeviceCreate) {
          <span class="page-title">Create Production Device</span>
        }
        @if (ProductionDeviceUpdate) {
          <span class="page-title">Update Production Device</span>
        }
      </div>
    </div>

    <div class="component-container">
      <!-- Component Header Section -->
      <div class="component-header">
        <h6 class="component-title">Production Device Details</h6>
      </div>

      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>

      <!-- Component Body Section -->
      <div class="component-body">
        <form
          [formGroup]="ProductionDeviceAddForm"
          novalidate
          (submit)="validateFormSave()"
        >
          <div class="form-section">
            <!-- UIN -->
            <div class="form-group">
              <label for="stateName" class="form-label">UID</label>
              <mat-form-field class="form-field" appearance="outline">
                <mat-label>UID</mat-label>
                <input
                  id="uid"
                  placeholder="UID"
                  formControlName="uid"
                  matInput
                  type="text"
                  required
                  [readonly]="ProductionDeviceUpdate"
                />
                @if (
                  ProductionDeviceAddForm.controls['uid'].touched &&
                  ProductionDeviceAddForm.controls['uid'].errors
                    ?.lengthCheckValidator
                ) {
                  <mat-error>
                    <span>{{
                      ProductionDeviceAddForm.controls['uid'].errors
                        ?.lengthCheckValidator
                    }}</span>
                  </mat-error>
                }
              </mat-form-field>
            </div>

            <!-- IMEI -->
            <div class="form-group">
              <label for="imei" class="form-label">IMEI</label>
              <mat-form-field class="form-field" appearance="outline">
                <mat-label>IMEI</mat-label>
                <input
                  id="imei"
                  placeholder="IMEI"
                  formControlName="imei"
                  matInput
                  required
                  type="text"
                  [readonly]="ProductionDeviceUpdate"
                />
                @if (
                  ProductionDeviceAddForm.controls['imei'].touched &&
                  ProductionDeviceAddForm.controls['imei'].errors
                    ?.lengthCheckValidator
                ) {
                  <mat-error>
                    <span>{{
                      ProductionDeviceAddForm.controls['imei'].errors
                        ?.lengthCheckValidator
                    }}</span>
                  </mat-error>
                }
              </mat-form-field>
            </div>

            <!-- ICCID -->
            <div class="form-group">
              <label for="iccid" class="form-label">ICCID</label>
              <mat-form-field class="form-field" appearance="outline">
                <mat-label>ICCID</mat-label>
                <input
                  id="iccid"
                  placeholder="ICCID"
                  formControlName="iccid"
                  matInput
                  required
                  type="text"
                  [readonly]="ProductionDeviceUpdate"
                />
                @if (
                  ProductionDeviceAddForm.controls['iccid'].touched &&
                  ProductionDeviceAddForm.controls['iccid'].errors
                    ?.lengthCheckValidator
                ) {
                  <mat-error>
                    <span>{{
                      ProductionDeviceAddForm.controls['iccid'].errors
                        ?.lengthCheckValidator
                    }}</span>
                  </mat-error>
                }
              </mat-form-field>
            </div>

            <!-- Device Model Name -->
            <div class="form-group">
              <label for="type" class="form-label">Device Model Name</label>
              <mat-form-field appearance="outline">
                <mat-label>Device Model Name</mat-label>
                <mat-select formControlName="modelName" required>
                  @for (model of modelList; track model) {
                    <mat-option [value]="model.modelName">
                      {{ model.modelName }}
                    </mat-option>
                  }
                </mat-select>
                @if (
                  ProductionDeviceAddForm.controls['modelName'].touched &&
                  ProductionDeviceAddForm.controls['modelName'].errors
                    ?.requiredAndNoEmptySpaces
                ) {
                  <mat-error>
                    <span>{{
                      ProductionDeviceAddForm.controls['modelName'].errors
                        ?.requiredAndNoEmptySpaces
                    }}</span>
                  </mat-error>
                }
              </mat-form-field>
            </div>

            <!-- ICCID SIM Card No -->
            <div class="form-group">
              <label for="portTwo" class="form-label">ICCID SIM Card No</label>
              <mat-form-field class="form-field" appearance="outline">
                <mat-label>ICCID SIM Card No</mat-label>
                <input
                  id="mobile"
                  placeholder="ICCID SIM Card No"
                  formControlName="mobile"
                  matInput
                  type="text"
                  required
                />
                @if (
                  ProductionDeviceAddForm.controls['mobile'].touched &&
                  ProductionDeviceAddForm.controls['mobile'].errors
                    ?.lengthCheckValidator
                ) {
                  <mat-error>
                    <span
                      >{{
                        ProductionDeviceAddForm.controls['mobile'].errors
                          ?.lengthCheckValidator
                      }}
                    </span>
                  </mat-error>
                }
              </mat-form-field>
            </div>

            <!-- Service Provider -->
            <div class="form-group">
              <label for="stateEnableOTACmd" class="form-label"
                >Service Provider</label
              >
              <mat-form-field class="form-field" appearance="outline">
                <mat-label>Service Provider</mat-label>
                <input
                  id="serviceProvider"
                  placeholder="Service Provider"
                  formControlName="serviceProvider"
                  matInput
                  type="text"
                  required
                />
                @if (
                  ProductionDeviceAddForm.controls['serviceProvider'].touched &&
                  ProductionDeviceAddForm.controls['serviceProvider'].errors
                    ?.requiredAndNoEmptySpaces
                ) {
                  <mat-error>
                    <span>{{
                      ProductionDeviceAddForm.controls['serviceProvider'].errors
                        ?.requiredAndNoEmptySpaces
                    }}</span>
                  </mat-error>
                }
              </mat-form-field>
            </div>

            <!-- Alt Mobile No -->
            <div class="form-group">
              <label for="stateEnableOTACmd" class="form-label"
                >Alt Mobile No</label
              >
              <mat-form-field class="form-field" appearance="outline">
                <mat-label>Alt Mobile No</mat-label>
                <input
                  id="altMobile"
                  placeholder="Alt Mobile No"
                  formControlName="altMobile"
                  matInput
                  type="text"
                />
                @if (
                  ProductionDeviceAddForm.controls['altMobile'].touched &&
                  ProductionDeviceAddForm.controls['altMobile'].errors
                    ?.lengthCheckValidator
                ) {
                  <mat-error>
                    <span
                      >{{
                        ProductionDeviceAddForm.controls['altMobile'].errors
                          ?.lengthCheckValidator
                      }}
                    </span>
                  </mat-error>
                }
              </mat-form-field>
            </div>

            <!-- Alt Service Provider -->
            <div class="form-group">
              <label for="stateEnableOTACmd" class="form-label"
                >Alt Service Provider</label
              >
              <mat-form-field class="form-field" appearance="outline">
                <mat-label>Alt Service Provider</mat-label>
                <input
                  id="altServiceProvider"
                  placeholder="Alt Service Provider"
                  formControlName="altServiceProvider"
                  matInput
                  type="text"
                />
                @if (
                  ProductionDeviceAddForm.controls['altServiceProvider']
                    .touched &&
                  ProductionDeviceAddForm.controls['altServiceProvider'].errors
                    ?.requiredAndNoEmptySpaces
                ) {
                  <mat-error>
                    <span>{{
                      ProductionDeviceAddForm.controls['altServiceProvider']
                        .errors?.requiredAndNoEmptySpaces
                    }}</span>
                  </mat-error>
                }
              </mat-form-field>
            </div>

            <!-- Firmware -->
            @if (projectName === 'Sampark') {
              <div class="form-group">
                <label for="stateEnableOTACmd" class="form-label"
                  >Firmware</label
                >
                <mat-form-field class="form-field" appearance="outline">
                  <mat-label>Firmware</mat-label>
                  <input
                    id="firmware"
                    placeholder="Firmware"
                    formControlName="firmware"
                    matInput
                    type="text"
                    required
                  />
                  @if (
                    ProductionDeviceAddForm.controls['firmware'].touched &&
                    ProductionDeviceAddForm.controls['firmware'].errors
                      ?.requiredAndNoEmptySpaces
                  ) {
                    <mat-error>
                      <span>{{
                        ProductionDeviceAddForm.controls['firmware'].errors
                          ?.requiredAndNoEmptySpaces
                      }}</span>
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            } @else {
              <div class="form-group">
                <label for="openCpuVersion" class="form-label"
                  >Open CPU Version</label
                >
                <mat-form-field class="form-field" appearance="outline">
                  <mat-label>Open CPU Version</mat-label>
                  <input
                    id="openCpuVersion"
                    placeholder="Open CPU Version"
                    formControlName="openCpuVersion"
                    matInput
                    type="text"
                  />
                </mat-form-field>
              </div>
              <div class="form-group">
                <label for="mcuVersion" class="form-label">MCU Version</label>
                <mat-form-field class="form-field" appearance="outline">
                  <mat-label>MCU Version</mat-label>
                  <input
                    id="mcuVersion"
                    placeholder="MCU Version"
                    formControlName="mcuVersion"
                    matInput
                    type="text"
                  />
                </mat-form-field>
              </div>
              <div class="form-group">
                <label for="bootVersion" class="form-label"
                  >Boot Loader Version</label
                >
                <mat-form-field class="form-field" appearance="outline">
                  <mat-label>Boot Loader Version</mat-label>
                  <input
                    id="bootVersion"
                    placeholder="Boot Loader Version"
                    formControlName="bootVersion"
                    matInput
                    type="text"
                  />
                </mat-form-field>
              </div>
              <div class="form-group">
                <label for="gpsVersion" class="form-label">GPS Version</label>
                <mat-form-field class="form-field" appearance="outline">
                  <mat-label>GPS Version</mat-label>
                  <input
                    id="gpsVersion"
                    placeholder="GPS Version"
                    formControlName="gpsVersion"
                    matInput
                    type="text"
                  />
                </mat-form-field>
              </div>
              <div class="form-group">
                <label for="gsmVersion" class="form-label">GSM Version</label>
                <mat-form-field class="form-field" appearance="outline">
                  <mat-label>GSM Version</mat-label>
                  <input
                    id="gsmVersion"
                    placeholder="GSM Version"
                    formControlName="gsmVersion"
                    matInput
                    type="text"
                  />
                </mat-form-field>
              </div>
              <div class="form-group">
                <label for="sdkVersion" class="form-label"
                  >Open CPU SDK Version</label
                >
                <mat-form-field class="form-field" appearance="outline">
                  <mat-label>Open CPU SDK Version</mat-label>
                  <input
                    id="sdkVersion"
                    placeholder="Open CPU SDK Version"
                    formControlName="sdkVersion"
                    matInput
                    type="text"
                  />
                </mat-form-field>
              </div>
            }

            <!-- SIM Vendor -->
            <!-- <div class="form-group">
              <label for="stateEnableOTACmd" class="form-label"
                >SIM Vendor</label
              >
              <mat-form-field class="form-field" appearance="outline">
                <mat-label>SIM Vendor</mat-label>
                <input
                  id="simVendor"
                  placeholder="SIM Vendor"
                  formControlName="simVendor"
                  matInput
                  type="text"
                  required
                />
                @if (
                  ProductionDeviceAddForm.controls['simVendor'].touched &&
                  ProductionDeviceAddForm.controls['simVendor'].errors
                    ?.requiredAndNoEmptySpaces
                ) {
                  <mat-error>
                    <span>{{
                      ProductionDeviceAddForm.controls['simVendor'].errors
                        ?.requiredAndNoEmptySpaces
                    }}</span>
                  </mat-error>
                }
              </mat-form-field>
            </div> -->

            <!-- Bootstrap Expiry Date -->
            <div class="form-group">
              <label for="portOne" class="form-label"
                >Bootstrap Expiry Date</label
              >
              <mat-form-field appearance="outline">
                <mat-label>Bootstrap Expiry Date</mat-label>
                <input
                  id="bootstrapExpDate1"
                  placeholder="Bootstrap Expiry Date"
                  formControlName="bootstrapExpDate"
                  required
                  readonly
                  matInput
                  [matDatepicker]="bootstrapExpDatePicker1"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="bootstrapExpDatePicker1"
                ></mat-datepicker-toggle>
                <mat-datepicker #bootstrapExpDatePicker1></mat-datepicker>
                @if (
                  ProductionDeviceAddForm.controls['bootstrapExpDate']
                    .touched &&
                  ProductionDeviceAddForm.controls['bootstrapExpDate'].errors
                    ?.isValidDate
                ) {
                  <mat-error>
                    <span>{{
                      ProductionDeviceAddForm.controls['bootstrapExpDate']
                        .errors?.isValidDate
                    }}</span>
                  </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </form>
      </div>
      <div class="component-separator"></div>
      <!-- Component Footer Section -->
      <div class="component-footer">
        <div class="button-group">
          @if (ProductionDeviceCreate) {
            <button
              class="submit-button"
              (click)="validateFormSave()"
              [disabled]="this.ProductionDeviceAddForm.invalid"
            >
              Submit <mat-icon class="btn-icon">check_circle</mat-icon>
            </button>
          }
          @if (ProductionDeviceUpdate) {
            <button class="edit-button" (click)="validateFormUpdate()">
              Update <mat-icon class="btn-icon">edit</mat-icon>
            </button>
          }
        </div>
      </div>
    </div>
  </form>
</div>
